import { applyTableStylesToViewer } from "client/Components/RichTextEditor/tableRendering";
import { ensureNotNil } from "client/Misc/utils";
import { hasImplicitDependencyOn } from "client/Misc/reactUtils";
import {
	ReactElement,
	useLayoutEffect,
	useRef
} from "react";
import { RawHtmlWithHoverableMentions } from "../../../../RawHtmlWithHoverableMentions/RawHtmlWithHoverableMentions";
import styles from "./Paragraph.module.less";

export type ParagraphProps = {
	html: string;
};

export const Paragraph = (props: ParagraphProps): ReactElement => {
	const {
		html
	} = props;

	const ref = useRef<HTMLDivElement>(null);

	useLayoutEffect(
		(): EffectWithDestructorResult => {
			hasImplicitDependencyOn(html);

			const container: HTMLDivElement = ensureNotNil(ref.current);
			applyTableStylesToViewer(container);
		},
		[html]
	);

	return (
		<div ref={ref} className={styles.root}>
			<RawHtmlWithHoverableMentions html={html} />
		</div>
	);
};
Paragraph.displayName = "ContentLayout.Paragraph";

